(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobxReact"), require("mobx"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaWorkflowForm"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "mobxReact", "mobx", "ReactDOM", "ReactRouter", "History", "weaWorkflowForm"], factory);
	else if(typeof exports === 'object')
		exports["weaWorkflowForm"] = factory(require("React"), require("mobxReact"), require("mobx"), require("ReactDOM"), require("ReactRouter"), require("History"), require("weaWorkflowForm"));
	else
		root["weaWorkflowForm"] = factory(root["React"], root["mobxReact"], root["mobx"], root["ReactDOM"], root["ReactRouter"], root["History"], root["weaWorkflowForm"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_185__, __WEBPACK_EXTERNAL_MODULE_722__, __WEBPACK_EXTERNAL_MODULE_724__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition